import React from "react";
import ArticleFeed from "../ArticleFeed";
import ArticleFeedItem from "../ArticleFeedItem";
import PublicationFeed from "../PublicationFeed";
import PublicationFeedItem from "../PublicationFeedItem";
import "./RelatedResearch.scss";
import PersonFeed from "../PersonFeed";
import PersonFeedItem from "../PersonFeedItem";
import EventFeed from "../EventFeed";
import EventFeedItem from "../EventFeedItem";

const RelatedResearch: React.FC<JQI.RelatedResearchProps> = ({
  publications,
  articles,
  people,
  events,
}) => {
  return (
    <section
      className="related-research"
      aria-labelledby="related-research-title">
      <div className="related-research__inner">
        {!!people && !!people.length && (
          <div className="related-research__people">
            <h2 className="related-research__title">Experts</h2>
            <PersonFeed>
              {people?.map((person, i) => (
                <PersonFeedItem
                  key={`person-${i}`}
                  name={person.name}
                  fields={person.fields}
                  relationships={person.relationships}
                />
              ))}
            </PersonFeed>
          </div>
        )}

        {!!publications?.length && (
          <div className="related-research__publications">
            <h2 className="related-research__title">Recent Publications</h2>
            <PublicationFeed>
              {publications.map((publication, i) => (
                <PublicationFeedItem
                  key={`publication-${i}`}
                  {...publication}
                />
              ))}
            </PublicationFeed>
          </div>
        )}
        {!!articles?.length && (
          <div className="related-research__articles">
            <h2 className="related-research__article-title">Recent Articles</h2>
            <ArticleFeed>
              {articles.map((article, i) => (
                <ArticleFeedItem key={`article-${i}`} {...article} />
              ))}
            </ArticleFeed>
          </div>
        )}

        {!!events && !!events.length && (
          <div className="related-research__events">
            <h2 className="related-research__title">Recent Events</h2>
            <EventFeed>
              {events?.map((event, i) => (
                <EventFeedItem
                  key={`event-${i}`}
                  title={event.title}
                  startDate={event.startDate}
                  fields={event.fields}
                  speakerName={event.speakerName}
                  speakerInstitution={event.speakerInstitution}
                  relationships={event.relationships}
                />
              ))}
            </EventFeed>
          </div>
        )}
      </div>
    </section>
  );
};

export default RelatedResearch;